import { YhBox } from '@/components/YhBox'
import useNavModel from '@/model/navModel'
import { Button, Upload } from 'antd'
import React from 'react'
import { useInquiryModel } from '../inquiryModel'
import { DataTable } from './DataTable'
import { globalPrompt } from '@/components/message'
import { useInquiryDetailsMode } from './details/inquiryDetailsModel'
import { importPropsConfig } from '@/utils/importFile'
import useGlobalModel from '@/model/globalModel'

export const DataBox = () => {
    const {setLoadingInfo } = useGlobalModel();
    const { selectedRowKeys, exportTemplate, loadData } = useInquiryModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel()
    const { resetEditCatch } = useInquiryDetailsMode()
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            //没有
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let purchaseDrEditKey = '3-2'
        let isFindNav = findNav(purchaseDrEditKey)
        if (!isFindNav) {
            addNav(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '询价单跳转详情',
                type: 'warning',
                text: '您还有询价单单详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }

    const onContrast = () => {
        if (selectedRowKeys.length !== 1) {
            //没有
            globalPrompt('message', { text: '请选择单条数据进行询价对比，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let purchaseDrEditKey = '3-3'
        let isFindNav = findNav(purchaseDrEditKey)
        if (!isFindNav) {
            addNav(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '询价对比跳转',
                type: 'warning',
                text: '您还有询价对比未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }


    const action = (
        <>
            <Button className="mr-5" type="link" shape="round" onClick={() => addNav('3-1', { id: '', mode: 'add' })}>
                新增
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={onEdit}>
                编辑
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={onContrast}>
                询价对比
            </Button>
           
        </>
    )
    return (
        <YhBox title="询价单列表" action={action}>
            <DataTable />
        </YhBox>
    )
}
